<template>
<div class="mixed-use-condominimum-wrapper">
  <p class="mixed-use-condominimum-saving m-0">
    Annual Savings: <span>$60,000</span>
  </p>
  <h3 class="mixed-use-condominimum-title m-0">Mixed-Use<br />
    Condominimum</h3>
  <p class="mixed-use-condominimum-description m-0">The hallmark of Manhattan Beach architectural design,
    the WAVE condominium is home to prime retail and
    community facility space.</p>
  <HelpButton text="Check if Your Project is Eligible" class="d-md-none mixed-use-condominimum-button" width="285px"></HelpButton>
  <div class="mixed-use-condominimum-img"></div>
</div>
</template>

<script>
import HelpButton from "@/components/HelpButton";
export default {
  name: "MixedUseCondominimum",
  components: {
    HelpButton
  }
}
</script>

<style scoped>
.mixed-use-condominimum-wrapper {
  padding-top: 40px;
  padding-bottom: 80px;
  padding-left: 98px; /* 113px - 15px (col-6 padding)  */
}
.mixed-use-condominimum-img{
  height: 280px;
  width: 480px;
  background: url("../assets/assets_icap_web/photo_4.png") no-repeat;
  background-size: cover;
  margin-top: 80px;
}

.mixed-use-condominimum-saving{
  width: 202px;
  color: #0A1250;
  font-family: "Open Sans";
  font-size: 15px;
  letter-spacing: 0;
  line-height: 25px;
}
.mixed-use-condominimum-saving span{
  color: #4D59EB;
  font-weight: 600;
  display: inline-block;
  position: relative;
  margin-left: 10px;
}
.mixed-use-condominimum-saving span:before{
  content: "";
  position: absolute;
  left: -1px;
  top: 24px;
  height: 12px;
  width: 62.55px;
  background: url("../assets/assets_icap_web/line_3.png") no-repeat;
  background-size: cover;
}
.mixed-use-condominimum-text-wrapper {
  padding-top: 44px;
}
.mixed-use-condominimum-title {
  height: 96px;
  width: 276px;
  color: #0A1250;
  font-family: "Open Sans";
  font-size: 38px;
  font-weight: 300;
  letter-spacing: 0;
  line-height: 48px;
  margin-top: 40px !important;
}
.mixed-use-condominimum-description {
  width: 387px;
  color: #0A1250;
  font-family: "Open Sans";
  font-size: 15px;
  letter-spacing: 0;
  line-height: 25px;
  margin-top: 20px !important;
}
.mixed-use-condominimum-button {
  margin-top: 44px;
}

.mixed-use-condominimum-button {
  margin-top: 44px;
}

@media screen and (min-width: 768px) and (max-width: 1439px) {
  .mixed-use-condominimum-wrapper {
    padding-top: 72px;
    padding-left: 22px;
  }
  .mixed-use-condominimum-img{
    height: 164px;
    width: 280px;
    margin: 56px 0 0 !important;
  }
  .mixed-use-condominimum-title {
    height: 72px;
    font-size: 28px;
    line-height: 36px;
    margin-top: 32px !important;
  }
  .mixed-use-condominimum-description {
    width: 282px;
    font-size: 15px;
    letter-spacing: 0;
    line-height: 25px;
    margin-top: 16px !important;
  }
}

@media screen and (min-width: 375px)  and (max-width: 767px) {
  .mixed-use-condominimum-wrapper {
    max-width: 350px;
    margin: 0 auto;
    border-right: none;
    padding-top: 32px;
    padding-left: 0;
    padding-bottom: 48px;
  }
  .mixed-use-condominimum-title {
    color: #0A1250;
    font-family: "Open Sans";
    font-size: 28px;
    font-weight: 300;
    letter-spacing: 0;
    line-height: 36px;
    margin-top: 32px !important;
  }

  .mixed-use-condominimum-description {
    width: 282px;
    color: #0A1250;
    font-family: "Open Sans";
    font-size: 15px;
    letter-spacing: 0;
    line-height: 25px;
    margin-top: 20px !important;
  }
  .mixed-use-condominimum-button {
    margin-top: 24px;
    margin-bottom: 48px;
  }

  .mixed-use-condominimum-img{
    height: 180px;
    width: 343px;
    margin: 0 !important;
  }
}
@media screen and (max-width: 374px) {
  .mixed-use-condominimum-wrapper {
    max-width: 350px;
    margin: 0 auto;
    border-right: none;
    padding-top: 32px;
    padding-left: 0;
    padding-bottom: 40px;
  }
  .mixed-use-condominimum-title {
    color: #0A1250;
    font-family: "Open Sans";
    font-size: 28px;
    font-weight: 300;
    letter-spacing: 0;
    line-height: 36px;
    margin-top: 32px !important;
    height: auto;
  }

  .mixed-use-condominimum-description {
    width: 282px;
    color: #0A1250;
    font-family: "Open Sans";
    font-size: 15px;
    letter-spacing: 0;
    line-height: 25px;
    margin-top: 20px !important;
  }
  .mixed-use-condominimum-button {
    margin-top: 24px;
    margin-bottom: 40px;
  }

  .mixed-use-condominimum-img{
    height: 180px;
    width: 288px;
    margin: 0 !important;
  }
}
</style>
